import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useEnableSimulatorMode = () => {
  const queryClient = useQueryClient();

  return apiClient.customsSimulator.enableBatchCustomsSimulator.useMutation({
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success(data.body.message || 'Simulator mode enabled for this batch');
    },
    onError: (error) => {
      showErrorToast(error, 'Error updating simulator mode');
    },
  });
};
